import { Map } from 'immutable'
import { PictureSources } from './images'

export const extraImageSizes = [
  // Page header small
  '520x217',
  '1040x434',
  '2080x868',
  // Page header large
  '520x600',
  '1040x600',
  '1560x600',
  '2080x600',
  '3120x1200',
  // Page header article
  '620x210',
  '1240x420',
  '2480x840',
  // Text with image & Featured content
  '320x216',
  '640x432',
  '960x648',
  // Grid with image
  '320x160',
  '640x320',
  '960x480',
  // CTA & Quote & Contact
  '160x160',
  '320x320',
  // Media
  '520w',
  '1040w',
  '2080w',
  // Nested media
  '570w',
  '760w',
  '1520w',
  // Advertisement
  '660x95'
] as const

export type ExtraImageSize = typeof extraImageSizes[number]

export const imageSizes = [...extraImageSizes, 'full'] as const

export type ImageSize = typeof imageSizes[number]

// Full

export const defaultSrc: ImageSize = 'full'

// Page header small
export const pageheaderSmallSrc: ImageSize = '520x217'
export const pageheaderSmallSrcSet: Map<ImageSize, string> = Map([
  ['520x217', '520w'],
  ['1040x434', '1040w'],
  ['2080x868', '2080w']
])
export const pageheaderSmallSources: Array<PictureSources> = []

// Page header large

export const pageheaderLargeSrc: ImageSize = '520x600'
export const pageheaderLargeSrcSet: Map<ImageSize, string> = Map([
  ['520x600', '520w'],
  ['1040x600', '1040w'],
  ['1560x600', '1560w'],
  ['2080x600', '2080w'],
  ['3120x1200', '3120w']
])
export const pageheaderLargeSources: Array<PictureSources> = []

// Page header article
export const pageheaderArticleSrc: ImageSize = '620x210'
export const pageheaderArticleSrcSet: Map<ImageSize, string> = Map([
  ['620x210', '620w'],
  ['1240x420', '1240w'],
  ['2480x840', '2480w']
])

export const pageheaderArticleSources: Array<PictureSources> = []

// Text with image

export const textImageSrc: ImageSize = '320x216'
export const textImageSrcSet: Map<ImageSize, string> = Map([
  ['320x216', '320w'],
  ['640x432', '640w'],
  ['960x648', '960w']
])

// Featured Content

export const listingItemSrc: ImageSize = '320x216'
export const listingItemSrcSet: Map<ImageSize, string> = Map([
  ['160x160', '160w'],
  ['320x216', '320w'],
  ['640x432', '640w'],
  ['960x648', '960w']
])
export const listingItemSources: Array<PictureSources> = []

// Featured Content

export const featuredContentSrc: ImageSize = '320x216'
export const featuredContentSrcSet: Map<ImageSize, string> = Map([
  ['320x216', '320w'],
  ['640x432', '640w'],
  ['960x648', '960w']
])
export const featuredContentSources: Array<PictureSources> = []

// Grid with image

export const linkGridSrc: ImageSize = '320x160'
export const linkGridSrcSet: Map<ImageSize, string> = Map([
  ['320x160', '320w'],
  ['640x320', '640w'],
  ['960x480', '960w']
])

// CTA

export const ctaSrc: ImageSize = '160x160'
export const ctaSrcSet: Map<ImageSize, string> = Map([
  ['160x160', '160w'],
  ['320x320', '320w']
])
export const ctaSources: Array<PictureSources> = []

// Quote

export const quoteSrc: ImageSize = '160x160'
export const quoteSrcSet: Map<ImageSize, string> = Map([
  ['160x160', '160w'],
  ['320x320', '320w']
])
export const quoteSources: Array<PictureSources> = []

// Contact

export const contactSrc: ImageSize = '160x160'
export const contactSrcSet: Map<ImageSize, string> = Map([
  ['160x160', '160w'],
  ['320x320', '320w']
])
export const contactSources: Array<PictureSources> = []

// Media

export const mediaSrc: ImageSize = '520w'
export const mediaSrcSet: Map<ImageSize, string> = Map([
  ['520w', '520w'],
  ['1040w', '1040w'],
  ['2080w', '2080w']
])
export const mediaFullSources: Array<PictureSources> = []

// Nested media
export const mediaNestedSrc: ImageSize = '570w'
export const mediaNestedSrcSet: Map<ImageSize, string> = Map([
  ['570w', '570w'],
  ['760w', '760w'],
  ['1520w', '1520w']
])
export const mediaNestedSources: Array<PictureSources> = []

// Search results

export const searchResultsSrc: ImageSize = textImageSrc
export const searchResultsSrcSet: Map<ImageSize, string> = textImageSrcSet

export const logoWallSrc: ImageSize = '160x160' // TODO: THIS SHOULD BE 160x90
export const logoWallSrcSet: Map<ImageSize, string> = Map([
  ['160x160', '160w'], // TODO: THIS SHOULD BE 160x90
  ['320x320', '320w'] // TODO: THIS SHOULD BE 320x180
])

export const advertisementSrc: ImageSize = '660x95'
export const advertisementSrcSet: Map<ImageSize, string> = Map([
  ['660x95', '660w']
])
